export const API_HOSTS = {
  production: 'api.vrplatform.app',
  preview: 'preview.api.vrplatform.app',
  staging: 'staging.api.vrplatform.app',
  local: 'localhost:8877',
  stagingEdge: 'staging.api.edge.vrplatform.app',
} as const;

export const API_ENVIRONMENT_OPTIONS = [
  { label: 'Production', value: API_HOSTS.production },
  { label: 'Preview', value: API_HOSTS.preview },
  { label: 'Staging', value: API_HOSTS.staging },
  { label: 'Local', value: API_HOSTS.local },
  { label: 'Edge (Staging)', value: API_HOSTS.stagingEdge },
] as const;

export const getDefaultApiHost = (hostname?: string) => {
  const resolvedHostname =
    hostname ??
    (typeof window === 'undefined' ? undefined : window.location.hostname);

  if (!resolvedHostname) return API_HOSTS.production;

  if (resolvedHostname === 'preview.portal.vrplatform.app') {
    return API_HOSTS.preview;
  }

  if (
    resolvedHostname === 'localhost' ||
    resolvedHostname === 'staging.portal.vrplatform.app' ||
    resolvedHostname.includes('app-256.pages.dev')
  ) {
    return API_HOSTS.staging;
  }

  return API_HOSTS.production;
};

export const normalizeApiHost = (value?: string | null) => {
  if (!value) return undefined;

  const trimmed = value.replaceAll('"', '').trim();
  if (!trimmed) return undefined;

  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    try {
      return new URL(trimmed).host;
    } catch {
      return trimmed;
    }
  }

  return trimmed;
};

export const resolveApiHost = (value?: string | null) =>
  normalizeApiHost(value) ?? getDefaultApiHost();

export const getApiBaseUrl = (host: string) => {
  const protocol = host.includes('localhost') ? 'http' : 'https';
  return host.startsWith('http://') || host.startsWith('https://')
    ? host
    : `${protocol}://${host}`;
};

// helper to fetch all items from an api endpoint
export async function fetchApiAllItems<TItem>(
  fetchItems: (
    page: number
  ) => Promise<{ items: TItem[]; hasNextPage: boolean }>,
  page = 1,
  prevs: TItem[] = []
): Promise<TItem[]> {
  const { items, hasNextPage } = await fetchItems(page);

  const newItems = prevs.concat(items);

  if (!hasNextPage) return newItems;

  const nextPage = page + 1;
  return await fetchApiAllItems(fetchItems, nextPage, newItems);
}
